export const orientationIsReverse = (o) => o === "rtl" || o === "btt";

export const orientationIsFlipped = (o) => o === "ttb" || o === "btt";

export function isDotted(string, fret, dots) {
	return !!dots.find(([x, y]) => x === string && y === fret);
}

export function fretDots(string, fret, dots) {
	return dots.filter(([x, y]) => x && y === fret).length;
}

export function getSideDots(string, fret, dots, strings) {
	if (string === strings.length) {
		return fretDots(string, fret, dots);
	}

	return 0;
}

export function fretNumber(n, frets, orientation = "ltr") {
	if (orientationIsReverse(orientation)) {
		return (frets - n);
	}

	return n;
}

export function stringNumber(n, strings, orientation = "ltr", stringLayout = "rh") {
	// Reversed layout
	if (stringLayout === "lh") {
		n = strings.length - 1 - n;
	}

	// Reversed orientation
	if (orientationIsReverse(orientation)) {
		n = strings.length - 1 - n;
	}

	// Flipped orientation
	if (orientationIsFlipped(orientation)) {
		n = strings.length - 1 - n;
	}

	return n;
}

export function fretWidth (fret) {
	// In ems; from 6 to 2

	return (Math.log(fret + 1.25) / Math.log(0.45)) + 6;
}
